import { useTranslation } from '../../../../hooks/useTranslation';
import { useQueryStateContext } from '../../../../contexts';
import { useVisualComponentsContext } from '../../../../contexts/visualComponents';
import { useFacetOptions } from '../useFacetOptions';
import { ValidatedSingleStringValueInputProps } from '../types';

export const SingleDoubleInput = ({
  value,
  onChange,
  isInvalid,
  isOpenByDefault,
  hasWarning,
  dataType,
  field,
  fieldType,
  comparator,
}: ValidatedSingleStringValueInputProps) => {
  const { t } = useTranslation();
  const { isReadOnly } = useQueryStateContext();
  const { ConditionValueSingleStringInput: VisualComponent } = useVisualComponentsContext();
  const { options, didError, isLoading } = useFacetOptions({
    dataType,
    field,
  });

  const isDisabled = isReadOnly || isLoading || didError;
  const hasError = didError || !!isInvalid;

  return (
    <VisualComponent
      onChange={onChange}
      value={value}
      hasError={hasError}
      hasWarning={hasWarning}
      isOpenByDefault={isOpenByDefault}
      isDisabled={isDisabled}
      dataType={dataType}
      field={field}
      fieldType={fieldType}
      comparator={comparator}
      options={options}
      placeholder={t('v2.conditionBuilder.singleDoublePlaceholder')}
    />
  );
};
